
const ReadyPlayerMeEvents = {
  AVATAR_EXPORTED: 'v1.avatar.exported',
  FRAME_READY: 'v1.frame.ready',
}

export default class ReadyPlayerAvatar {
  constructor() {
    this.createAvatarBtnContainer = document.getElementById('create-avatar-btn-container');
    this.createAvatarBtn = this.createAvatarBtnContainer?.querySelector('#create-avatar-btn');
    if (this.createAvatarBtn) {
      this.frame = document.getElementById('actionFrame');
      this.initEventListener();
    }
  }

  initEventListener() {
    window.addEventListener('message', this.subscribe.bind(this));
    document.addEventListener('message', this.subscribe.bind(this));
  }

  subscribe(event) {
    const json = this.parse(event);

    if (json?.source !== 'readyplayerme') {
      return;
    }

    // Subscribe to all events sent from Ready Player Me once frame is ready
    if (json.eventName === ReadyPlayerMeEvents.FRAME_READY) {
      this.frame.contentWindow.postMessage(
        JSON.stringify({
          target: 'readyplayerme',
          type: 'subscribe',
          eventName: 'v1.**'
        }),
        '*'
      );
    }

    // Get avatar GLB URL
    if (json.eventName === ReadyPlayerMeEvents.AVATAR_EXPORTED) {
      top.initModalSpinner('#actionModalForm', 'Saving you avatar');
      const avatarImageUrl = this.get2DImage(json.data.avatarId);
      this.saveAvatar(avatarImageUrl);
    }
  }

  get2DImage(avatarId) {
    const url = new URL(`https://models.readyplayer.me/${avatarId}.png`);
    url.searchParams.set('background', '50,54,55');
    url.searchParams.set('camera', 'portrait');
    url.searchParams.set('blendShapes[mouthSmile]', '0.8');
    return url.href
  }

  saveAvatar(imageUrl) {
    const  { saveUrl, successUrl } = this.createAvatarBtnContainer.dataset;
    $.ajax({
      url: saveUrl,
      type: 'post',
      data: {
        avatar_url: imageUrl,
      },
      success: () => {
        top.closeAction();
        top.document.location = successUrl;
      }
    });
  }

  parse(event) {
    try {
      return JSON.parse(event.data);
    } catch (error) {
      return null;
    }
  }
}
